module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fields selection",
    class: {
      'checked': _vm.selection.participants.indexOf(_vm.participant.id) > -1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selection.participants),
      expression: "selection.participants"
    }],
    attrs: {
      "type": "checkbox",
      "name": "participants[]",
      "id": _vm.participant.id,
      "disabled": !_vm.available
    },
    domProps: {
      "value": _vm.participant.id,
      "checked": Array.isArray(_vm.selection.participants) ? _vm._i(_vm.selection.participants, _vm.participant.id) > -1 : (_vm.selection.participants)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.selection.participants,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.participant.id,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selection.participants = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selection.participants = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selection.participants = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.participant.id
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.name.joined) + " "), _c('small', [_vm._v("(DOB: " + _vm._s(_vm.dob) + ")")])]), _vm._v(" "), (!_vm.available) ? _c('div', {
    staticClass: "subtitle red"
  }, [_vm._v("\n            " + _vm._s(_vm.$parent.$parent.locale.text_existing_child_wrong_enough) + "\n        ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56656cfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/builder/PackageOptions/ExistingParticipant.vue
// module id = 176
// module chunks = 0